// Translations
import landing from '../views/landing/translations/tr'

// Translation: Verification (Turkish)
export default Object.freeze({
	name: 'Doğrulama',
	views: { landing }
})
